import api from './api'
import { Region } from 'models/regions'

export const fetchRegions = async () => {
    const resp = await api.get<Region[]>('/regions')

    return resp.data
}
